module.exports = __webpack_public_path__ + "img/CITEC.d0e6fc4f.png";